function Loader() {
  return (
    <div className="appLoader">
      <div className="appLoaderWrapper">
        <div className="dot1" />
        <div className="dot2" />
        <div className="dot3" />
      </div>
    </div>
  );
}

export default Loader;
